import {defineMessages, FormattedMessage} from 'react-intl';
import {view} from '@sail/ui/deprecated';
import {MetaRow} from './MetaRow';

const messages = defineMessages({
  participantLeft: {
    id: 'conversations_ui.chat.row.participantLeft',
    description: 'Message to show as in a conversation when someone leaves.',
    defaultMessage: '{name} has left.',
  },
});

export const LeaveRow = ({name}: {name: string}) => (
  <view.div data-testid="leave-row">
    <MetaRow>
      <FormattedMessage {...messages.participantLeft} values={{name}} />
    </MetaRow>
  </view.div>
);
